import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HeaderScene from './HeaderScene';
import Nav from './Nav';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #2d1441;
  padding: 20px 0;
  @media (max-width: 768px) {
    padding: 0;
  }

  ${({ gradient }) =>
    gradient &&
    `
      background-color: #270046;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 360px;
        background: linear-gradient(to bottom, #2D0052 0%, #4D008C 50%, #F1F0F3 100%);
        backdrop-filter: blur(92px);
        @media (min-width: 769px) {
          height: 548px;
      }
    }
  `}
`;

const Header = ({ gradient }) => (
  <HeaderWrapper gradient={gradient}>
    <Nav />
    {!gradient && <HeaderScene />}
  </HeaderWrapper>
);

Header.propTypes = {
  gradient: PropTypes.bool,
};

Header.defaultProps = {
  gradient: false,
};

export default Header;
